import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Amazonservices(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text=" Combination">
                            <h2>TekRevol & Oracle – A Powerful Combination</h2>
                        </div>
                        {/*<div*/}
                        {/*    className="main_para"><p>SAP is a one-of-its-kind, turnkey ERP system that synchronizes*/}
                        {/*    different business departments and brings them on one page to achieve organizational goals.*/}
                        {/*    It significantly improves internal communications, opens avenues for enhanced, recorded*/}
                        {/*    collaborations, and allows better internal reporting.</p>*/}
                        {/*</div>*/}
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">On Point Cloud Building Solutions</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">360 Degree Customer Experience Reinvention</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Effective Business Process Management</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>

                                        <Tab.Pane eventKey="0">
                                            <p>TekRevol’s developers love the secure, hybrid cloud environment of Oracle. In addition to being the right database choice, it blends seamlessly with our tech stack, suits diverse business requirements, supports different business journeys, and accelerates operation and technical growth.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>One major strength of Oracle’s cloud applications and solutions is efficient data analytics – the core behind modern custom excellence campaigns with high ROI. It helps us build customer experiences and capabilities for CRMs, POS, and lead gen solutions.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>Oracle makes selecting the right hyper-scale solutions matching the current state and organizational growth plans easier. While it helps build strong foundations for ERP systems, it also allows easy identity management, provides flexible user control and offers superior scalability.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>On Point Cloud Building Solutions</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol’s developers love the secure, hybrid cloud environment of Oracle. In addition to being the right database choice, it blends seamlessly with our tech stack, suits diverse business requirements, supports different business journeys, and accelerates operation and technical growth.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>360 Degree Customer Experience Reinvention</Accordion.Header>
                                    <Accordion.Body>
                                        <p>One major strength of Oracle’s cloud applications and solutions is efficient data analytics – the core behind modern custom excellence campaigns with high ROI. It helps us build customer experiences and capabilities for CRMs, POS, and lead gen solutions.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Effective Business Process Management</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Oracle makes selecting the right hyper-scale solutions matching the current state and organizational growth plans easier. While it helps build strong foundations for ERP systems, it also allows easy identity management, provides flexible user control and offers superior scalability.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Amazonservices;